const REQUEST_NATURES = [
  "Hardware Issue",
  "Software Issue",
  "Software Procurement",
  "Information Technology",
  "Information Security",
  "Financial Services",
  "Creative Technology",
  "Other"
];

export { REQUEST_NATURES };
